import React, { useState, useEffect } from "react";
import { getExamSubjectList ,getSubmitedExamRegistration} from "../../services/ExamService";
import { LabelMedium } from "../common/GlobalElements/Typography";

export default function ExamSubjectAppendReadOnly(props) {
  const [subjectList, setSubjectList] = useState([]);
  const [listData, setListData] = useState([]);
  const { formik } = props;
  const isWithHeldStatus = localStorage.getItem("resultWithHeld");

  useEffect(() => {
    getExamSubjectList(props.examId).then((res) => {
      setSubjectList(res.data);
    });
  }, [props.examId]);


  useState(() => {
    getSubmitedExamRegistration(props.examId).then((res) => {
      setListData(res.data.examSubjectList)
    });
  }, [props.examId]);


  return (
    <>
      <div className="table-responsive instructions-table">
        <div className="d-flex add-row-head w-100">
          <div className="form-group col-5 cust_tbl_col_1 m-0">
            <LabelMedium>
              <strong>Subject:</strong>
            </LabelMedium>
          </div>
          <div className="form-group col-2 cust_tbl_col_2 m-0">
            <LabelMedium>
              <strong>Is this your first attempt?</strong>
            </LabelMedium>
          </div>

          <div className="form-group col-2 cust_tbl_col_3  m-0">
            <LabelMedium><strong>Term Mark</strong></LabelMedium>
          </div>

          <div className="form-group col-1 cust_tbl_col_4 m-0">
            <LabelMedium><strong>Written</strong></LabelMedium>
          </div>

          <div className="form-group col-2 cust_tbl_col_5 m-0">
            <LabelMedium><strong>DHET Result</strong></LabelMedium>
          </div>
        </div>

        <div className="d-flex add-row-repeat w-100">
          <div className="form-group">
            <LabelMedium className="color-red">
              <strong>
                Important: Term mark for selected Intake will be used
              </strong>
            </LabelMedium>
          </div>
        </div>
        {/* End  add-row-repeat */}


        {formik.values.subject_.map((subject, index) => (
          <div className="d-flex add-row-repeat w-100 parent_div" key={index}>
            <div className="form-group col-5 cust_tbl_col_1  m-0">

              {listData && listData.length ? (
                <select
                  className={
                    "form-control " +
                    (formik.touched.subject_ && formik.errors.subject_
                      ? " is-invalid"
                      : "")
                  }
                  name={`subject_[${index}]`}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  key={index}
                  value={formik.values.subject_[index]}
                  disabled="disabled"
                >
                  <option value="">---</option>
                  {listData.map((element, index2) => {
                    return (
                      <option
                        key={index2}
                        value={element.intake_id}
                      >{`${element.subject_name}-
                      Intake ${element.intake_number}, ${element.intake_year}
                      `}</option>
                    );
                  })}
                </select>
                
              ) : null}
            </div>
            <div className="form-group col-2 cust_tbl_col_2  m-0">
               {listData && listData.length ? (
                <select
                  className={
                    "form-control " +
                    (formik.touched.subject_ && formik.errors.subject_
                      ? " is-invalid"
                      : "")
                  }
                  name={`subject_[${index}]`}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  key={index}
                  value={listData.find(elem => elem.intake_id ===formik.values.subject_[index] && elem.first) ? "1" : "0"}
                  disabled="disabled"
                >
                  {listData.map((element, index2) => {
                    return (
                     <>

                     {element.first ==1 && 
                      <option key={`${index}_1`} value="1">
                       Yes
                    </option>
                     }
                  
                     {element.first ==0 && 
                      <option key={`${index}_2`} value="0">
                       No
                    </option>
                     }
                     </>
                    );
                  })}
                </select>
                
              ) : null}
            </div>
            {isWithHeldStatus!= "true" ? 
            <div className="form-group col-2 cust_tbl_col_3 ui-select  m-0">
            {listData && listData.length ? (                
                <select
                  className={
                    "form-control " +
                    (formik.touched.subject_ && formik.errors.subject_
                      ? " is-invalid"
                      : "")
                  }
                  name={`subject_[${index}]`}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  key={index}
                  value={formik.values.subject_[index]}
                  disabled="disabled"
                >
                  <option value="">---</option>
                  {listData.map((element, index2) => {
                    return (
                      <option
                        key={index2}
                        value={element.intake_id}
                      >{`${element.mark}`}</option>
                    );
                  })}
                </select>
             
                
              ) : null}
              
            </div>
            :<div title={'Your marks are being withheld due to outstanding balances on your account, you will have limited access to the portal. Please contact the finance department by logging a ticket'} className="col-2 cust_tbl_col_3 m-0 witheld-status">Results Withheld</div>}            
            <div className="form-group col-1 cust_tbl_col_4  m-0">
            {listData && listData.length ? (                
                <select
                  className={
                    "form-control " +
                    (formik.touched.subject_ && formik.errors.subject_
                      ? " is-invalid"
                      : "")
                  }
                  name={`subject_[${index}]`}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  key={index}
                  value={listData.find(elem => elem.intake_id ===formik.values.subject_[index] && elem.written) ? "1" : "0"}
                  disabled="disabled"
                >
                  {listData.map((element, index2) => {
                    return (
                      <>
                        {element.written ==1 && 
                        <option key={`${index}_1`} value="1">
                          Yes
                        </option>
                        }

                        {element.written == 0 && 
                        <option key={`${index}_2`} value="0">
                          No
                        </option>
                        }
                        </>
                    );
                  })}
                </select>
             
                
              ) : null}
              
            </div>
            {isWithHeldStatus!= "true" ? 
            <div className="form-group col-2 cust_tbl_col_5 m-0">
            {listData && listData.length ? (
                <select
                  className={
                    "form-control remove" +
                    (formik.touched.subject_ && formik.errors.subject_
                      ? " is-invalid"
                      : "")
                  }
                  name={`subject_[${index}]`}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  key={index}
                  value={formik.values.subject_[index]}
                  disabled="disabled"
                >
                  <option value="">---</option>
                  {listData.map((element, index2) => {
                    return (
                      <option
                        key={index2}
                        value={element.intake_id}
                      >{`${element.dhetresult==''?'---':element.dhetresult}`}</option>
                    );
                  })}
                </select>
              ) : null}
              
            </div>
            :<div title={'Your marks are being withheld due to outstanding balances on your account, you will have limited access to the portal. Please contact the finance department by logging a ticket'} className="col-2 cust_tbl_col_5 m-0 witheld-status">Results Withheld</div>}
            
          </div>
        ))}

      </div>
    </>
  );
}
